<template>
  <header>
    <a :href="(homeURL)">
      <img src="/app/themes/leightons/images/updated-logo.png" width="267" height="80"/>
    </a>
  </header>
</template>

<script>
export default {

  created() {
    this.currentURL = location.host;
    let noneBookingUrl = location.host.replace('uatbooking.', window.domainPrefix ? window.domainPrefix : 'uat.');
    noneBookingUrl = noneBookingUrl.replace('staging-booking.', window.domainPrefix ? window.domainPrefix : '');
    noneBookingUrl = noneBookingUrl.replace('booking.', window.domainPrefix ? window.domainPrefix : '');
    this.homeURL = location.protocol + "//" + noneBookingUrl;
    this.bookingURL = location.protocol + "//" + location.host;
  },

  name: "PageHeader",
  data () {
    return {
      currentURL: "",
      logo: require('@/assets/logo.png')
    }
  }
};
</script>

<style lang="postcss" scoped>
header {
  @apply border-b-2 border-purple-darker;

  a {
        @apply block bg-white text-center px-xs py-10;

    img {
      @apply w-[144px] h-[auto] sm:w-[267px] sm:h-[80px] bg-cover mx-auto;
    }
  }

}
</style>